import React from 'react';
import { Link } from 'react-router';
import wNumb from 'wnumb';

let priceFormat = wNumb({
    prefix: '$',
    decimals: 0,
    thousand: ','
});

import { onEnquireClick } from '../../common/onEnquireClick';
import getPpsUrl from '../../common/ppsUrl';

const PackageSearchGridItem = (props) => {

    let price = priceFormat.to(props.data.price);
    const ppsUrl = getPpsUrl(props.data.pps_url);

    return (
        <div className="w-100 w-50-md w-33-lg w-25-wd fl p-a-1-md p-b-1">
            <div className="relative">
                <a href={props.data.link}>
                    <img className="select-package-image relative" src={props.data.render} alt=""/>
                    <img className="select-package-builder" src={props.data.logo} alt=""/>
                </a>
            </div>

            <div className="ins-grid-content">
                <div className="ins-grid-title">
                    <Link to={props.data.link}>
                        <p className="select-package-header small-blue-font m-b-1">Lot {props.data.lot} - {props.data.name}</p>
                    </Link>
                </div>

                <div className="ins-grid-price">
                    <div className="fl w-50 tl">
                        <p className="select-package-price"><span className="small-grey-font">From  </span>{price}</p>
                    </div>


                </div>

                <div className="ins-grid-details">
                    <div className="fl w-50 tl">
                        <p className="small-grey-font">Land Size<span className="fcolor-og small-grey-font"> {props.data.area}m<sup>2</sup></span></p>
                    </div>



                    <div className="fr w-50 tr">
                        <p className="small-grey-font">Frontage<span className="fcolor-og small-grey-font"> {props.data.frontage}m</span></p>
                    </div>
                </div>

	            <div className="ins-grid-features">
		            <ul>
			            <li> <span>{props.data.bed}</span>&nbsp;<img className="fr" src='https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/assets/images/icons/bed.svg' alt="" width="25px"/></li>
			            <li>&nbsp;&nbsp;<span>{props.data.bath}</span>&nbsp;<img className="fr" src='https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/assets/images/icons/bathtub.svg' alt="" width="25px"/></li>
			            <li>&nbsp;&nbsp;<span>{props.data.car}</span>&nbsp;<img className="fr" src='https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/assets/images/icons/car.svg' alt="" width="25px"/></li>
		            </ul>
	            </div>

                <div className="ins-grid-actions">
                    <div className="fl w-50 select-package-download-icon">
                        <a className="download-flyer" href={props.data.pdf + '?package=' + props.data.id} target="_blank" rel="noopener noreferrer">
                            <i className="icon icon--download-alt"></i>
                            <span className="small-grey-font">Download Flyer</span>
                        </a>
                        {ppsUrl ? (
                            <a className="download-flyer pps-card-download" href={ppsUrl} target="_blank" rel="noopener noreferrer">
                                <i className="icon icon--download-alt"></i>
                                <span className="small-grey-font">Download PPS</span>
                            </a>
                        ) : (
                            <span className="download-flyer pps-card-download pps-card-download-spacer" aria-hidden="true"></span>
                        )}
                    </div>

                    <div className="fr w-50">
                        <a className="btn btn__enquire js-registrationModal fr" role="button" onClick={(ev) => onEnquireClick(ev, props.data.builder, props.data.name, props.data.lot)}>
                            <span className="btn-land-available">ENQUIRE</span>
                        </a>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default PackageSearchGridItem;


/** WEBPACK FOOTER **
 ** ./src/modules/house-and-land/elements/PackageSearchGridItem.js
 **/